import React, { useEffect } from "react";
import { ScrollToTop } from "../components/ScrollToTop";

const Disclaimer = () => {
  useEffect(() => {
    
  }, []);
  return (
    <section class="max-w-4xl mx-auto px-4 py-8">
      <h1 class="text-3xl font-bold mb-4">Disclaimer</h1>
      <p class="text-sm text-gray-500 mb-6">Updated at 2023-06-20</p>

      <p class="mb-4">
        Sairah, a venture of Soradis Group under Soradis Jewellers Private
        Limited, hereby grants you access to{" "}
        <a href="https://sairahjewels.com/" class="text-blue-600 underline">
          https://sairahjewels.com/
        </a>{" "}
        (“the Website”) and invites you to purchase the services offered here.
      </p>

      <h2 class="text-2xl font-semibold mt-8 mb-3">
        Definitions and Key Terms
      </h2>
      <ul class="list-disc list-inside space-y-2 mb-6">
        <li>
          <strong>Cookie:</strong> Small amount of data generated by a website
          and saved by your browser, used to identify your browser, provide
          analytics, and remember preferences.
        </li>
        <li>
          <strong>Company:</strong> Refers to Soradis Jewellers Private Limited,
          2029, NIBR Corporate Park, Aerocity, Andheri (E), Mumbai.
        </li>
        <li>
          <strong>Service:</strong> The services provided by Sairah, as
          described in the relevant terms and on the platform.
        </li>
        <li>
          <strong>Website:</strong> The site accessible via{" "}
          <a href="https://sairahjewels.com/" class="text-blue-600 underline">
            https://sairahjewels.com/
          </a>
          .
        </li>
        <li>
          <strong>You:</strong> A person or entity registered with Sairah to use
          the Services.
        </li>
      </ul>

      <h2 class="text-2xl font-semibold mt-8 mb-3">Limited Liability</h2>
      <p class="mb-4">
        We strive to keep the website content up-to-date and accurate. However,
        errors may occur. All materials are provided without guarantee and can
        change at any time without notice.
      </p>
      <p class="mb-4">
        Prices are subject to typing or programming errors. No agreements are
        made based on such errors.
      </p>
      <p class="mb-4">
        We are not liable for external links. Other sites may have different
        terms and privacy policies. Always verify before interacting with
        third-party sites.
      </p>

      <h2 class="text-2xl font-semibold mt-8 mb-3">Links to Other Websites</h2>
      <p class="mb-4">
        This Disclaimer applies only to our services. We do not control or
        endorse other sites linked here. Always review third-party policies
        before use.
      </p>

      <h2 class="text-2xl font-semibold mt-8 mb-3">Errors and Omissions</h2>
      <p class="mb-4">
        We are not responsible for inaccuracies or omissions in content or code
        and do not provide warranties. Use of the service is at your own risk.
      </p>

      <h2 class="text-2xl font-semibold mt-8 mb-3">General Disclaimer</h2>
      <p class="mb-4">
        Our service is provided "as is" and "as available" with no express or
        implied warranties. We do not guarantee uninterrupted or error-free
        service and are not responsible for third-party content.
      </p>

      <h2 class="text-2xl font-semibold mt-8 mb-3">Copyright</h2>
      <p class="mb-4">
        All content is the intellectual property of Soradis Jewellers Private
        Limited. Reproduction or distribution is prohibited unless permitted by
        law or written consent.
      </p>

      <h2 class="text-2xl font-semibold mt-8 mb-3">Testimonials</h2>
      <p class="mb-4">
        Testimonials are personal experiences and not guarantees of results.
        Outcomes may vary. We are committed to transparency and authenticity in
        all shared reviews.
      </p>

      <h2 class="text-2xl font-semibold mt-8 mb-3">Your Consent</h2>
      <p class="mb-4">
        By using our site or services, you consent to this Disclaimer and agree
        to its terms.
      </p>

      <h2 class="text-2xl font-semibold mt-8 mb-3">
        Changes to This Disclaimer
      </h2>
      <p class="mb-4">
        We may update this document to reflect changes in our services.
        Continued use implies acceptance of the updated terms.
      </p>

      <h2 class="text-2xl font-semibold mt-8 mb-3">Contact Us</h2>
      <ul class="list-disc list-inside mb-8">
        <li>
          <strong>Email:</strong>{" "}
          <a
            href="mailto:support@sairahjewels.com"
            class="text-blue-600 underline"
          >
            support@sairahjewels.com
          </a>
        </li>
        <li>
          <strong>Phone: </strong>
          <a href="tel:8828826996" class="text-blue-600 underline">
            {` `}8828826996
          </a>
        </li>
      </ul>
    </section>
  );
};

// const Section = ({ title, children }) => (
//   <section className="mb-8">
//     <h2 className="text-2xl font-semibold mb-2">{title}</h2>
//     {children}
//   </section>
// );

export default Disclaimer;
